<template>
  <div v-if="parsedTitle" class="banner" :style="{ backgroundColor: colour }">
    <h1 class="title -regular -white" v-html="parsedTitle" />
    <p v-if="text" class="text" v-html="text" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import lightenDarkenColor from "@/util/LightenDarkenColor";

export default {
  props: {
    title: String,
    text: String,
    colour: String,
    secondaryColour: String,
  },
  computed: {
    ...mapState(["home"]),
    parsedTitle() {
      if (!this.home) {
        return this.title;
      }
      return this.title.replace("[[home]]", this.home.name);
    },
    lightenedColour() {
      return lightenDarkenColor(this.colour, 40);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "foundation-sites/scss/foundation.scss";
@import "@/assets/scss/_settings";
.banner {
  min-height: vw-relative(220);
  padding: vw-relative(20, 320);
  display: flex;
  flex-direction: column;
  justify-content: center;
  @include breakpoint(medium) {
    padding: vw-relative(20 500 20 120);
  }
}
.title {
  margin-bottom: 0.4em;
}
</style>
